import React from 'react'
import GenericPullAndPushToolView from '../GenericPullAndPushToolView'
import SonraiConfigListing from './SonraiConfigListing'
import SonraiCredentialsForm from './SonraiCredentialsForm'

export default function SonraiPullAndPushView(props) {
    return (
        <GenericPullAndPushToolView 
            {...props}
            PullCredentialForm={SonraiCredentialsForm}
            PullConfigListingView={SonraiConfigListing}
        />
    )
}